import { render, staticRenderFns } from "./ReportsRentabilityEdit.vue?vue&type=template&id=32d80b43&scoped=true&"
import script from "./ReportsRentabilityEdit.vue?vue&type=script&lang=js&"
export * from "./ReportsRentabilityEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d80b43",
  null
  
)

export default component.exports